export default __webpack_public_path__ + "static/prateek-aeeac7716b85a32b587a94b08357c09a.jpeg";